import { render, staticRenderFns } from "./ProductFamilySectionInfo.vue?vue&type=template&id=15306e6f&"
import script from "./ProductFamilySectionInfo.vue?vue&type=script&lang=js&"
export * from "./ProductFamilySectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports